import { AFRICAN_COUNTRIES } from "@/context/countries";
import React, { useState, useRef, useEffect } from "react";

import styles from './CustomDropdown.module.scss';

export default function CountryDropdown({ onChangeFunc, value = "" }) {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(AFRICAN_COUNTRIES[0]);
  const [atTop, setAtTop] = useState(true);
  const [atBottom, setAtBottom] = useState(false);

  const dropdownRef = useRef(null);
  const listRef = useRef<HTMLDivElement>(null);
  const scrollInterval = useRef<NodeJS.Timeout | null>(null);

  useEffect(()=>{
    const selectedCountry = AFRICAN_COUNTRIES.find(
      (country) => country.code == value
    );
    if (selectedCountry) {
      setSelected(selectedCountry);
    } else {
      setSelected(AFRICAN_COUNTRIES[0]);
    }
  },[value])

  

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  const handleSelect = (country: (typeof AFRICAN_COUNTRIES)[0]) => {
    setSelected(country);
    onChangeFunc(country.code);
    setIsOpen(false);
  };

  const updateScrollState = () => {
    if (!listRef.current) return;
    const el = listRef.current;
    setAtTop(el.scrollTop === 0);
    setAtBottom(el.scrollHeight - el.scrollTop <= el.clientHeight + 1);
  };

  const startScroll = (direction: "up" | "down") => {
    const amount = direction === "up" ? -5 : 5;
    scrollInterval.current = setInterval(() => {
      if (listRef.current) {
        listRef.current.scrollBy({ top: amount });
        updateScrollState();
      }
    }, 20);
  };

  const stopScroll = () => {
    if (scrollInterval.current) {
      clearInterval(scrollInterval.current);
      scrollInterval.current = null;
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !(dropdownRef.current as HTMLElement).contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (listRef.current) {
      updateScrollState();
      listRef.current.addEventListener("scroll", updateScrollState);
    }
    return () => {
      if (listRef.current) {
        listRef.current.removeEventListener("scroll", updateScrollState);
      }
    };
  }, []);

  return (
    <div className={styles.dropdown} ref={dropdownRef}>
      <div className={styles.dropdownToggle} onClick={toggleDropdown}>
        <div className={styles.countryCode}>
          {selected.countryCode} {value}
        </div>
        <div>
          <svg
            width="13"
            height="9"
            viewBox="0 0 13 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 1L6.62222 7L0.999999 1"
              stroke="#686868"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
        </div>
      </div>
      {isOpen && (
        <div className={styles.dropdownMenuWrapper}>
          <div
            className={styles.scrollArrow}
            onMouseEnter={() => startScroll("up")}
            onMouseLeave={stopScroll}
            style={{ visibility: atTop ? "hidden" : "visible" }}
          >
            <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
              <path
                d="M5 13L10 8L15 13"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div className={styles.dropdownMenu} ref={listRef}>
            {AFRICAN_COUNTRIES.map((country) => (
              <div
                key={country.countryCode}
                className={styles.dropdownItem}
                onClick={() => handleSelect(country)}
              >
               {selected.code == country.code ? "✔" : <span className={styles.spanWidth}></span>} {country.country} {country.code}
              </div>
            ))}
          </div>
          <div
            className={styles.scrollArrow}
            onMouseEnter={() => startScroll("down")}
            onMouseLeave={stopScroll}
            style={{ visibility: atBottom ? "hidden" : "visible" }}
          >
            <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
              <path
                d="M5 7L10 12L15 7"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
      )}
    </div>
  );
}
